import React, { useState } from "react";
import {
  LayoutDashboard,
  PieChart,
  Users,
  TrendingUp,
  Eye,
  UserCircle,
  Settings,
  Newspaper,
  Beaker,
  BedDouble,
} from "lucide-react";

const Help = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  const tabs = [
    {
      value: "dashboard",
      label: "Dashboard",
      icon: <LayoutDashboard size={18} />,
      videoUrl: "38gDtvneSFQ",
    },
    {
      value: "analytics",
      label: "Analytics",
      icon: <PieChart size={18} />,
      videoUrl: "4HvL8tlowCk",
    },
    {
      value: "residents",
      label: "Residents",
      icon: <Users size={18} />,
      videoUrl: "Q3UsGsyxF_A",
    },
    {
      value: "recovery-capital",
      label: "Recovery Capital",
      icon: <TrendingUp size={18} />,
      videoUrl: "idgoGsZq4Qc",
    },
    {
      value: "owner-dashboard",
      label: "Owner Dashboard",
      icon: <Eye size={18} />,
      videoUrl: "0Jk5GDdDf4g",
    },
    {
      value: "resident-dashboard",
      label: "Resident Dashboard",
      icon: <UserCircle size={18} />,
      videoUrl: "40yUW-IlxNI",
    },
    {
      value: "ua",
      label: "UA",
      icon: <Beaker size={18} />,
      videoUrl: "wlgP6pWLGyY",
    },
    {
      value: "bed-platform",
      label: "Bed Platform",
      icon: <BedDouble size={18} />,
      videoUrl: "apSObRlQmNg",
    },
    {
      value: "settings-permissions",
      label: "Settings & Permissions",
      icon: <Settings size={18} />,
      videoUrl: "0v1KcS0-i8A",
    },
    {
      value: "custom-forms",
      label: "Custom Forms",
      icon: <Newspaper size={18} />,
      videoUrl: "9wG-bjXK2jA",
    },
  ];

  return (
    <div className="min-h-screen bg-[#0A0F1E] text-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Help Center</h1>

        {/* Tabs */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`flex items-center justify-center gap-2 p-4 rounded-xl transition-all duration-200 border border-slate-700
                ${
                  activeTab === tab.value
                    ? "bg-gradient-to-r from-cyan-500 to-cyan-600 text-white"
                    : "bg-slate-800/50 hover:bg-slate-700/50 text-slate-300"
                }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className={`bg-slate-900/95 backdrop-blur-xl border border-slate-800/30 rounded-xl
              ${activeTab === tab.value ? "block" : "hidden"}`}
          >
            <div className="p-6">
              {/* Video Section */}
              <div className="aspect-video rounded-lg overflow-hidden bg-slate-800/50 mb-6">
                {tab.videoUrl ? (
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${tab.videoUrl}`}
                    title={`${tab.label} Tutorial`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-slate-400">
                    Video tutorial coming soon
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Help;
